import api from 'api/api'
import { openCenter } from 'components/filters/useStreamFilters'
import { mintedOrdinalId } from './mintedOrdinalId'

// Mints started from the ordinals stream have no user thread to land on: when
// one finishes, open the ordinal's system thread. Keyed by the hidden
// mint-source answer id that the mint status events carry.
const pendingSystemThreadOpens = new Set<string>()

export function openSystemThreadWhenMinted(answerId: string) {
    pendingSystemThreadOpens.add(String(answerId))
}

export function cancelSystemThreadOpen(answerId: string | null) {
    if (answerId) pendingSystemThreadOpens.delete(String(answerId))
}

// Returns true when it took over navigation for this answer.
export function openSystemThreadForMintedAnswer(answerId: string | null): boolean {
    if (!answerId || !pendingSystemThreadOpens.has(String(answerId))) return false
    pendingSystemThreadOpens.delete(String(answerId))
    ;(async () => {
        try {
            const answer = await api.getAnswer(String(answerId))
            const ordinalId = mintedOrdinalId(answer)
            if (!ordinalId) return
            const thread = await api.ensureOrdinalThread(ordinalId)
            if (thread?.child_quest_id) openCenter({ questId: thread.child_quest_id })
        } catch (error) {
            console.error('Could not open the minted ordinal thread:', error)
        }
    })()
    return true
}
